import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCaretButtonDownProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCaretButtonDownSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCaretButtonDownSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M8.00669 10.5133L4.75336 7.25329L5.92669 6.07996L8.00669 8.15329L10.08 6.07996L11.26 7.25329L8.00669 10.5133Z" />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCaretButtonDownSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M8.00666 10.04L4.98666 7.02002L5.69333 6.31335L8.00666 8.62669L10.3133 6.31335L11.0267 7.02002L8.00666 10.04Z" />
    </svg>
  );
}

export default function IconCaretButtonDown({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCaretButtonDownProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
